// extracted by mini-css-extract-plugin
export default {"headerContainer":"MgbjX"};